import React, { useEffect, useState } from "react";
import User, { EmptyUser } from "../types/User";

type Props = {
  children: React.ReactChild;
};

type Input = {
  name: string;
  picture: string;
};
type View = {
  sidebar: boolean;
  name: string;
  url: string;
};
const DefaultView: View = {
  sidebar: true,
  name: "quest",
  url: "/roadmap/timeline",
};
type TimeView = {
  label: string;
  value: "week" | "month";
};
const DefaultTimeView: TimeView = {
  label: "Monthly View",
  value: "month",
};

type UserContextType = {
  user: User;
  roadmapView: View;
  timeView: TimeView;
  searchView: boolean;
  isSignedIn: boolean;
  selectedVersion: number;
  [key: string]: any;
};

export const UserContext = React.createContext<UserContextType>({
  user: EmptyUser,
  isSignedIn: false,
  roadmapView: DefaultView,
  searchView: false,
  timeView: DefaultTimeView,
  selectedVersion: 0,
  selectedVName: "",
  setCurrentRoadmapView: (view: View) => {},
  setSearchView: (searchView: boolean) => {},
  setCurrentTimeView: (timeView: TimeView) => {},
  setCurrentUser: (user: User) => {},
  signOut: () => {},
  setVersion: (value: number) => {},
  setVersionName: (value: number) => {},
});

const UserContextProvider = (props: Props) => {
  const [user, setUser] = useState<User>(EmptyUser);
  const [userProgram, setUserProgram] = useState(user?.programs?.[0] || "B.ENG. AiCE");
  const [roadmapView, setRoadmapView] = useState<View>(DefaultView);
  const [timeView, setTimeView] = useState<TimeView>(DefaultTimeView);
  const [searchView, setSearchView] = useState<boolean>(false);
  const [isSignedIn, setSignedIn] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState(0);
  const [selectedVersionName, setSelectedVersionName] = useState("")

  const setCurrentUser = (user: User) => {
    setUser(user);
    user?.programs && setUserProgram(user?.programs?.[0]);
    if (user.id) {
      setSignedIn(true);
    } else {
      setSignedIn(false);
    }
  };
  const setCurrentRoadmapView = (view: View) => {
    localStorage.setItem("roadmapView", JSON.stringify(view));
    setRoadmapView({ ...roadmapView, name: view.name, url: view.url });
  };
  const setCurrentTimeView = (timeView: TimeView) => {
    localStorage.setItem("timeView", JSON.stringify(timeView));
    setTimeView({ ...timeView, label: timeView.label, value: timeView.value });
  };
  const setSidebarView = (view: boolean) => {
    // setTimeout(() => {
    setRoadmapView({ ...roadmapView, sidebar: view });
    // }, 200);
  };

  const signOut = () => {
    localStorage.clear();
    setSignedIn(false);
    setCurrentUser(EmptyUser);
  };

  const setVersion = (value: number) => {
    setSelectedVersion(value);
  };
   const setVersionName = (value: string) => {
    setSelectedVersionName(value);
  };
  return (
    <UserContext.Provider
      value={{
        user,
        roadmapView,
        timeView,
        searchView,
        isSignedIn,
        selectedVersion,
        selectedVersionName,
        userProgram,
        setCurrentTimeView,
        setCurrentRoadmapView,
        setSearchView,
        setSidebarView,
        setCurrentUser,
        signOut,
        setVersion,
        setVersionName
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
